import React, { ReactNode, memo, useMemo } from 'react';

import { useLocation } from 'react-router';

import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

export interface SidebarItemProps {
  label: string;
  icon?: ReactNode;
  url: string;
}

const SidebarItem = memo(function SidebarItem({ label, icon, url }: SidebarItemProps) {
  const { hash } = useLocation();
  const isSelected = useMemo(() => hash === url, [hash, url]);

  return (
    <ListItem
      sx={{
        py: 0,
        px: 0,
      }}
    >
      <ListItemButton
        component="a"
        href={url}
        selected={isSelected}
        sx={{
          paddingLeft: 1.5,
          paddingRight: 0,
        }}
      >
        {icon && (
          <ListItemIcon
            sx={{
              '&.MuiListItemIcon-root': {
                minWidth: '40px',
              },
              color: isSelected ? 'primary.main' : 'text.secondary',
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        <ListItemText primary={label} />
      </ListItemButton>
    </ListItem>
  );
});

export default SidebarItem;
